import styled from 'styled-components';

export const BaseColumnWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
    `,
);

export const Cancel_policy_wrap = styled.div(
  props => `
      display:flex;
      flex-direction: column;
      `,
);

export const CancelList_Wrap = styled.ul(
  props => `
    display:flex;
    flex-direction:column;
    li{
    display:flex;
    margin-bottom:${props.theme.spacing.custom(21)};
    flex-direction: revert;
    align-items: baseline;
    margin: 5px 10px;
      `,
);

export const Left_wrap = styled.div(
  props => `
    width:7px;
    height:7px;
    border-radius:50%;
    background:black;
    flex-shrink: 0;
    margin-right:10px;
    `,
);

export const Text_Head = styled.p(
  props => `
     font-size: ${props.theme.font.custom(14)};
     font-weight: bold;
     margin-bottom:${props.theme.spacing.custom(2)};

      `,
);

export const Text_Heading = styled.p(
  props => `
     font-size: ${props.theme.font.custom(14)};
     font-weight: bold;
     margin-bottom:${props.theme.spacing.custom(6)};

      `,
);
